import { createFileRoute } from "@tanstack/react-router"

import { breadcrumbJsonLd, buildHead } from "@/core/seo"

import { ProductPage } from "../../components/landing"
import { MILEAGE_TRACKER_ZH, MILEAGE_SEO_ZH } from "../../content/zh/products/mileage-tracker"

/** Chinese version of /mileage-tracker (D-WEB-LANG-SCOPE); the English route carries the hreflang pair too. */
export const mileageTrackerZhSeo = () =>
  buildHead({
    ...MILEAGE_SEO_ZH,
    path: MILEAGE_TRACKER_ZH.path,
    localePrefix: "zh",
    jsonLd: [breadcrumbJsonLd([{ name: "首页", path: "/zh" }, { name: MILEAGE_TRACKER_ZH.name }])],
  })

export const Route = createFileRoute("/_brand-layout/zh/mileage-tracker")({
  head: () => {
    const { meta, links, scripts } = mileageTrackerZhSeo()
    return { meta, links, scripts }
  },
  component: MileageTrackerZhPage,
})

export function MileageTrackerZhPage() {
  return <ProductPage content={MILEAGE_TRACKER_ZH} />
}
